export type OrderByCondition = { [columnName: string]: "ASC"|"DESC" };
